import React from 'react';

import {AppLayout} from './app-layout';

/**
 * Renders `AppLayout` instead of `Layout`.
 *
 * `layout.tsx` is regenerated on every stencil upgrade, so app chrome cannot
 * live there. `app-layout.tsx` is `file.Once` because that whole file is the
 * customization: replace it to own the shell. Stencil will not overwrite it.
 * The default re-exports `Layout`, so apps that do not customize still receive
 * template updates to the shell.
 */

export const getLayout = (page: React.ReactElement) => {
    return <AppLayout>{page}</AppLayout>;
};
